<template>
  <SoRadioGroup
    ref="medical-equipment-input"
    v-model="extraInformation.hasMedicalEquipment"
    :items="[
      { text: 'No', value: false },
      { text: 'Yes', value: true },
    ]"
    label="Does the customer have any medical equipment which requires electricity?"
    @update:model-value="$emit('update:model-value', extraInformation)"
  />
  <p v-if="extraInformation.defaultComments" class="mb-4">
    Engineer note: {{ extraInformation.defaultComments }}
  </p>
  <SoTextarea
    ref="additional-comments-input"
    v-model="extraInformation.additionalComments"
    :max-length="maxLength"
    label="Is there anything else our engineer should be aware of on the day?"
    placeholder="Please provide any further details..."
    counter
    @update:model-value="$emit('update:model-value', extraInformation)"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { LocationQuery } from "vue-router"
  import SoRadioGroup from "@/components/formControls/SoRadioGroup.vue"
  import SoTextarea from "@/components/formControls/SoTextarea.vue"
  import { jobTypes, IMBP_TEXT_AREA_MAX_LENGTH } from "@/constants/imbp"

  export default defineComponent({
    components: {
      SoTextarea,
      SoRadioGroup,
    },
    props: {
      modelValue: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ["update:model-value"],
    data() {
      return {
        jobTypes,
        maxLength: IMBP_TEXT_AREA_MAX_LENGTH,
        extraInformation: {
          hasMedicalEquipment: false,
          defaultComments: "",
          additionalComments: "",
        },
        additionalNotesDisabled: false,
      }
    },
    created() {
      this.autoPopulateFields(this.$route.query)
      this.$emit("update:model-value", this.extraInformation)
    },
    methods: {
      autoPopulateFields(query: LocationQuery) {
        if (!query.job) return

        const job = this.jobTypes.find((job) => job.name === query.job)

        if (!job?.params) return

        if (job.params.notes) {
          this.extraInformation.defaultComments = job.params.notes + ` `
        }
      },
    },
  })
</script>
